export function isPdfUploadFile(file) {
  if (!file) return false;
  const mimeType = String(file.type || '').trim().toLowerCase();
  if (mimeType === 'application/pdf') return true;
  return mimeType === '' && /\.pdf$/i.test(String(file.name || '').trim());
}
